import React, { useState } from "react";
import blogService from "../../services/blogService";
import { useToast } from "../../context/ToastContext";

export default function BlogCommentForm({ blogId, onCommentSubmitted, parentId = null, onCancel }) {
  const { addToast } = useToast();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    comment: ''
  });
  const [submitting, setSubmitting] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.name || !formData.email || !formData.comment) {
      addToast('Please fill in all required fields', 'error');
      return;
    }

    setSubmitting(true);
    try {
      const response = await blogService.createComment(blogId, {
        author_name: formData.name,
        author_email: formData.email,
        content: formData.comment,
        parent_id: parentId
      });

      if (response.success) {
        addToast('Comment submitted successfully', 'success');
        setFormData({ name: '', email: '', comment: '' });
        if (onCommentSubmitted) {
          onCommentSubmitted(response.data);
        }
      } else {
        addToast('Failed to submit comment', 'error');
      }
    } catch (error) {
      console.error('Error submitting comment:', error);
      addToast(error.response?.data?.message || 'Failed to submit comment', 'error');
    } finally {
      setSubmitting(false);
    }
  };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };
  return (
    <div className="border border-purple/30 bg-[#160e24] rounded-[10px] p-4 md:p-[50px]">
      <h1 className="text-[30px] tracking-tight font-semibold text-white pb-6">
        Leave a Reply
      </h1>
      <p className="text-paragraph mb-[30px]">
        {parentId ? 'Leave a Reply' : 'Your email address will not be published. Required fields are marked *'}
      </p>
      <form onSubmit={handleSubmit} className="grid grid-cols-6 md:grid-cols-12 gap-[30px]">
        <input
          type="text"
          name="name"
          value={formData.name}
          onChange={handleChange}
          placeholder="Full Name *"
          required
          className="col-span-6 px-5 rounded-md h-14 outline-purple focus:outline-1 bg-[#0f0a1a] text-white placeholder-gray-400"
        />
        <input
          type="email"
          name="email"
          value={formData.email}
          onChange={handleChange}
          placeholder="Email *"
          required
          className="col-span-6 px-5 rounded-md h-14 outline-purple focus:outline-1 bg-[#0f0a1a] text-white placeholder-gray-400"
        />
        <textarea
          name="comment"
          value={formData.comment}
          onChange={handleChange}
          placeholder="Comments *"
          required
          className="col-span-6 md:col-span-12 px-5 py-4 outline-purple focus:outline-1 h-[100px] rounded-md bg-[#0f0a1a] text-white placeholder-gray-400"
        ></textarea>


        <div className="col-span-6 md:col-span-12 flex gap-4">
          <button
            type="submit"
            disabled={submitting}
            className="home-two-btn-bg py-3 group bg-[#4A7DFF] border-[#4A7DFF] inline-flex disabled:opacity-50 disabled:cursor-not-allowed"
          >
            <span className="text-base text-white group-hover:text-[#4A7DFF] transition-all duration-300 font-inter relative z-10">
              {submitting ? 'Sending...' : (parentId ? 'Post Reply' : 'Send Comments')}
            </span>
            <svg
              className="relative z-10"
              width="7"
              height="12"
              viewBox="0 0 7 12"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                className="group-hover:stroke-[#4A7DFF] transition-all duration-300"
                d="M1.10254 10.5L4.89543 6.70711C5.22877 6.37377 5.39543 6.20711 5.39543 6C5.39543 5.79289 5.22877 5.62623 4.89543 5.29289L1.10254 1.5"
                stroke="white"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              ></path>
            </svg>
          </button>

          {onCancel && (
            <button
              type="button"
              onClick={onCancel}
              className="py-3 px-6 text-base text-white hover:text-purple transition-all duration-300 font-inter"
            >
              Cancel
            </button>
          )}
        </div>
      </form>
    </div>
  );
}
